function string_to_slug(str) {
    str = str.replace(/^\s+|\s+$/g, '')
    str = str.toLowerCase()
  
    var from = 'õãàáäâèéëêìíïîòóöôùúüûñç·/_,:;'
    var to = 'oaaaaaeeeeiiiioooouuuunc------'
    for (var i = 0, l = from.length; i < l; i++) {
      str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i))
    }
  
    str = str
      .replace(/[^a-z0-9 -]/g, '')
      .replace(/\s+/g, '_')
      .replace(/-+/g, '-')
    return str
  }
  
  export default string_to_slug
  